import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import JyotishLinks from '../../../components/JyotishLinks/JyotishLink';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './Initial.scss';

const nakshatraData = [
  {
    id: 1,
    name: 'Ashwini, अश्विनी',
    pada: ['चु (Chu)', 'चे (Che)', 'चो (Cho)', 'ला (Laa)'],
  },
  {
    id: 2,
    name: 'Bharani, भरणी',
    pada: ['ली (Lee)', 'लू (Loo)', 'ले (Le)', 'लो (Lo)'],
  },
  {
    id: 3,
    name: 'Krittika, कृत्तिका',
    pada: ['अ (A)', 'ई (Ee)', 'उ (U)', 'ए (E)'],
  },
  {
    id: 4,
    name: 'Rohini, रोहिणी',
    pada: ['ओ (O)', 'वा (Vaa)', 'वी (Vee)', 'वु (Vu)'],
  },
  {
    id: 5,
    name: 'Mrigashira, मृगशिरा',
    pada: ['वे (Ve)', 'वो (Vo)', 'का (Kaa)', 'की (Kee)'],
  },
  {
    id: 6,
    name: 'Ardra, आर्द्रा',
    pada: ['कु (Ku)', 'घ (Gha)', 'ङ (Ing)', 'छ (Cha)'],
  },
  {
    id: 7,
    name: 'Punarvasu, पुनर्वसु',
    pada: ['के (Ke)', 'को (Ko)', 'हा (Haa)', 'ही (Hee)'],
  },
  {
    id: 8,
    name: 'Pushya, पुष्य',
    pada: ['हू (Hu)', 'हे (He)', 'हो (Ho)', 'दा (Daa)'],
  },
  {
    id: 9,
    name: 'Ashlesha, अश्लेषा',
    pada: ['डी (Dee)', 'डू (Doo)', 'डे (De)', 'डो (Do)'],
  },
  {
    id: 10,
    name: 'Magha, मघा',
    pada: ['मा (Maa)', 'मी (Mee)', 'मु (Moo)', 'मे (Me)'],
  },
  {
    id: 11,
    name: 'Purva Phalguni, पूर्वा फाल्गुनी',
    pada: ['मो (Mo)', 'टा (Taa)', 'टी (Tee)', 'टू (Too)'],
  },
  {
    id: 12,
    name: 'Uttara Phalguni, उत्तर फाल्गुनी',
    pada: ['टे (Te)', 'टो (To)', 'पा (Paa)', 'पी (Pee)'],
  },
  {
    id: 13,
    name: 'Hasta, हस्त',
    pada: ['पू (Poo)', 'ष (Sha)', 'ण (Naa)', 'ठ (Tha)'],
  },
  {
    id: 14,
    name: 'Chitra, चित्रा',
    pada: ['पे (Pe)', 'पो (Po)', 'रा (Raa)', 'री (Ree)'],
  },
  {
    id: 15,
    name: 'Swati, स्वाती',
    pada: ['रू (Roo)', 'रे (Re)', 'रो (Ro)', 'ता (Taa)'],
  },
  {
    id: 16,
    name: 'Vishakha, विशाखा',
    pada: ['ती (Tee)', 'तू (Too)', 'ते (Te)', 'तो (To)'],
  },
  // Add more as needed...
];

const Initial = () => {
  return (
    <div className="initial-container">
        <InnerNav/>
    <div className="nakshatra-table-content">
        <Zodiac/>
      <h2>Nakshatra and Padas</h2>
      <table className="nakshatra-table">
        <thead>
          <tr>
            <th>No</th>
            <th>Nakshatra Name</th>
            <th>Pada 1</th>
            <th>Pada 2</th>
            <th>Pada 3</th>
            <th>Pada 4</th>
          </tr>
        </thead>
        <tbody>
          {nakshatraData.map((item) => (
            <tr key={item.id}>
              <td>{item.id}</td>
              <td>{item.name}</td>
              <td>{item.pada[0]}</td>
              <td>{item.pada[1]}</td>
              <td>{item.pada[2]}</td>
              <td>{item.pada[3]}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <JyotishLinks/>
    </div>
    <Footer/>
</div>
  );
};

export default Initial;
